import React from 'react';
import type { ReactElement } from 'react';
import { createRoot } from 'react-dom/client';
import type { Root as ReactRoot } from 'react-dom/client';

import '@philips-internal/oswald-ui-components';
import '@philips-emr/patient-components';

import { Foundation } from '@philips-internal/oswald-ui-foundation';

import bootstrap from './app/bootstrap-foundation';

import './controllers';

function Root(): ReactElement {
  return (
    <Foundation
      bootstrap={bootstrap}
      root={{
        fragmentName: 'app',
      }}
    />
  );
}

declare global {
  interface Window {
    reactRoot: ReactRoot | undefined;
  }
}

if (!window.reactRoot) {
  const container = document.getElementById('root') as HTMLElement;
  window.reactRoot = createRoot(container);
}

window.reactRoot.render(<Root />);
